// extracted by mini-css-extract-plugin
module.exports = {"root":"SimpleHeader_root__uSEQ4","container":"SimpleHeader_container__GwNBl","logo":"SimpleHeader_logo__2ow67"};